/**
 * URL pattern matching utility
 *
 * Checks if the current path contains or matches a URL pattern.
 * Used by NavQuickLinks to determine active state.
 *
 * @param currentPath - The current browser path (e.g., from useRouter().asPath)
 * @param pattern - The URL pattern to match against (can be partial)
 * @returns boolean - true if the pattern is found in the current path
 */
export function containsPattern(
  currentPath: string | undefined | null,
  pattern: string | undefined | null
): boolean {
  if (!currentPath || !pattern) return false;

  // Remove query strings and hash for comparison
  const cleanPath = currentPath.split('?')[0].split('#')[0];
  const cleanPattern = pattern.split('?')[0].split('#')[0];

  // Direct match
  if (cleanPath === cleanPattern) return true;

  // Pattern is contained in path
  if (cleanPath.includes(cleanPattern)) return true;

  // Try regex match for more complex patterns
  try {
    const regex = new RegExp(cleanPattern);
    return regex.test(cleanPath);
  } catch {
    // If pattern is not valid regex, fall back to simple includes
    return false;
  }
}
